module.exports = __webpack_public_path__ + "static/media/lights.9eeb8564.jpg";